/* ==========================================================================
   px-story.js  —  progressive enhancement for the product description
   Loaded with `defer` by sections/px-product-story.liquid.

   Everything the shopper needs is already in the HTML (static tables, open FAQ
   items, plain summary). This file only adds:
     1. the interactive runtime / propane calculators (hidden until we run)
     2. an active-section highlight on the jump nav
     3. a sticky-header offset so jump links do not land under the header
     4. analytics:  story_nav_click, story_faq_open, story_calc_use, section_view

   If this file fails to load, the page is still complete.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.px-story');
  if (!root) return;

  /* ---- analytics (never throws, never blocks) -------------------------------- */
  function track(name, data) {
    try {
      var d = data || {};
      d.handle = root.getAttribute('data-px-handle') || '';
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('ikimsoft:' + name, d);
      }
    } catch (e) { /* analytics must never break the page */ }
  }

  /* ---- same formatting as tools/build-story.mjs fmtHours() --------------------- */
  function fmtHours(h) {
    if (!isFinite(h) || h <= 0) return '';
    if (h < 1) return Math.max(1, Math.round(h * 60)) + ' min';
    if (h < 10) return String(parseFloat(h.toFixed(1))) + ' h';
    if (h < 48) return Math.round(h) + ' h';
    return String(parseFloat((h / 24).toFixed(1))) + ' days';
  }
  function num(n) { return Number(n).toLocaleString('en-US'); }

  /* ---- 1. calculators ----------------------------------------------------------- */
  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, c = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(c, a); }, ms);
    };
  }

  function initPower(el) {
    var tool = el.querySelector('.px-calc__tool');
    var sel = el.querySelector('.px-calc__sel');
    var inp = el.querySelector('.px-calc__w');
    var out = el.querySelector('.px-calc__out');
    if (!tool || !sel || !inp || !out) return;

    var wh = parseFloat(el.getAttribute('data-px-wh'));
    var eff = parseFloat(el.getAttribute('data-px-eff')) || 0.8;
    var max = parseFloat(el.getAttribute('data-px-max'));
    var boost = parseFloat(el.getAttribute('data-px-boost')) || 0;
    if (!wh || !max) return;

    function render(watts, source) {
      out.removeAttribute('data-state');
      if (!watts || watts < 1) { out.textContent = ''; return; }
      if (watts > max && !(boost && watts <= boost)) {
        out.setAttribute('data-state', 'warn');
        out.textContent = num(watts) + ' W is above this unit’s ' + num(max) + ' W output.';
        return;
      }
      if (watts > max) {
        out.innerHTML = 'About ' + fmtHours((wh * eff) / watts) +
          '<small>' + num(watts) + ' W is above the ' + num(max) + ' W rating, so it only works if the device supports X-Boost (up to ' + num(boost) + ' W). Check the device before you rely on it.</small>';
        return;
      }
      out.innerHTML = 'About ' + fmtHours((wh * eff) / watts) +
        '<small>At ' + num(watts) + ' W, from a full charge. Estimate: ~' + Math.round(eff * 100) + '% of ' + num(wh) + ' Wh is usable.</small>';
    }

    var send = debounce(function (w, src) { track('story_calc_use', { calc: 'power', watts: w, source: src }); }, 700);

    sel.addEventListener('change', function () {
      inp.value = '';
      var w = parseFloat(sel.value);
      render(w, 'preset');
      send(w, 'preset');
    });
    inp.addEventListener('input', function () {
      var w = parseFloat(inp.value);
      if (!w) { var p = parseFloat(sel.value); render(p, 'preset'); return; }
      render(w, 'custom');
      send(w, 'custom');
    });

    render(parseFloat(sel.value), 'preset');
    tool.hidden = false;
  }

  function initPropane(el) {
    var tool = el.querySelector('.px-calc__tool');
    var sel = el.querySelector('.px-calc__sel');
    var pct = el.querySelector('.px-calc__pct');
    var out = el.querySelector('.px-calc__out');
    if (!tool || !sel || !pct || !out) return;
    var tank = parseFloat(el.getAttribute('data-px-btu-tank'));
    if (!tank) return;

    function render() {
      var btu = parseFloat(sel.value) * parseFloat(pct.value);
      if (!btu) { out.textContent = ''; return; }
      out.innerHTML = 'One full 20 lb tank lasts about ' + fmtHours(tank / btu) +
        '<small>Burning ' + num(Math.round(btu)) + ' BTU/h. Estimate from a full tank (~430,000 BTU). Wind, cold and a half-full tank shorten it.</small>';
    }
    var send = debounce(function () {
      track('story_calc_use', { calc: 'propane', btu: parseFloat(sel.value) * parseFloat(pct.value) });
    }, 500);
    sel.addEventListener('change', function () { render(); send(); });
    pct.addEventListener('change', function () { render(); send(); });
    render();
    tool.hidden = false;
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-px-calc]'), function (el) {
    var kind = el.getAttribute('data-px-calc');
    if (kind === 'power') initPower(el);
    else if (kind === 'propane') initPropane(el);
  });

  /* ---- 2. jump nav: active state + analytics ------------------------------------ */
  var links = Array.prototype.slice.call(root.querySelectorAll('.px-story__nav a[href^="#"]'));
  var byId = {};
  links.forEach(function (a) {
    byId[a.getAttribute('href').slice(1)] = a;
    a.addEventListener('click', function () {
      track('story_nav_click', { section: a.getAttribute('href').slice(1) });
    });
  });

  function setActive(id) {
    links.forEach(function (a) {
      if (a === byId[id]) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
    var cur = byId[id];
    if (cur && cur.scrollIntoView && cur.parentNode && cur.parentNode.parentNode) {
      var ul = cur.parentNode.parentNode;
      // keep the active chip visible in the horizontal strip (mobile) without moving the page
      if (ul.scrollWidth > ul.clientWidth) {
        var left = cur.parentNode.offsetLeft - 16;
        ul.scrollTo ? ul.scrollTo({ left: left, behavior: 'smooth' }) : (ul.scrollLeft = left);
      }
    }
  }

  if ('IntersectionObserver' in window && links.length) {
    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting ? en.intersectionRect.top : null; });
      var best = null;
      Object.keys(visible).forEach(function (id) {
        if (visible[id] === null) return;
        if (best === null || visible[id] < visible[best]) best = id;
      });
      if (best && byId[best]) setActive(best);
    }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });
    links.forEach(function (a) {
      var s = document.getElementById(a.getAttribute('href').slice(1));
      if (s) io.observe(s);
    });
  }

  /* ---- 3. sticky header offset --------------------------------------------------- */
  function setTop() {
    var top = 0;
    try {
      var hdr = document.querySelector('.ik-head2, .section-header, header.header, sticky-header, .header-wrapper');
      if (hdr) {
        var pos = window.getComputedStyle(hdr).position;
        if (pos === 'sticky' || pos === 'fixed') top = Math.round(hdr.getBoundingClientRect().height);
      }
    } catch (e) { top = 0; }
    var shell = root.closest('.px-story-shell') || root;
    shell.style.setProperty('--ps-top', top + 'px');
  }
  setTop();
  window.addEventListener('resize', debounce(setTop, 200), { passive: true });

  /* ---- 4. FAQ + section_view analytics -------------------------------------------- */
  Array.prototype.forEach.call(root.querySelectorAll('.px-faq__item'), function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      var s = d.querySelector('summary');
      track('story_faq_open', { question: s ? s.textContent.trim().slice(0, 120) : '' });
    });
  });

  if ('IntersectionObserver' in window) {
    var seen = false;
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !seen) {
          seen = true;
          track('section_view', { section: 'px-story' });
          vo.disconnect();
        }
      });
    }, { threshold: 0.15 });
    vo.observe(root);
  }
})();
